const optimizerRoutes = [
  {
    path: '',
    component: () => import('@/app/shared/layouts/main/Main.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/optimizer/explore',
        name: 'optimizerExplore',
        component: () => import('./views/Optimizer.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'price-mind' },
            { title: 'explore', active: true },
          ],
          pageTitle: 'PriceMind',
          rule: 'editor'
        }
      },
      {
        path: '/orbit/optimizer',
        name: 'orbitOptimizer',
        component: () => import('./views/Optimizer.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'price-mind' },
            { title: 'dashboard', active: true },
          ],
          pageTitle: 'PriceMind',
          rule: 'editor'
        }
      }
    ]
  }
];

export default optimizerRoutes;
